"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFadeInOut = void 0;
const react_1 = require("react");
const useFadeInOut = (show) => {
    const [display, setDisplay] = (0, react_1.useState)(show);
    const [animateIn, setAnimateIn] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let timeout;
        if (show) {
            setDisplay(true);
            timeout = window.setTimeout(() => {
                setAnimateIn(true);
            }, 10);
        }
        else {
            setAnimateIn(false);
            timeout = window.setTimeout(() => {
                setDisplay(false);
            }, 150);
        }
        return () => {
            window.clearTimeout(timeout);
        };
    }, [show]);
    return {
        display,
        animateIn,
    };
};
exports.useFadeInOut = useFadeInOut;
